export const formatDate = (inputDate: string): string => {
	const options: Intl.DateTimeFormatOptions = {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
	};

	const date = new Date(inputDate);
	const formattedDate: string = date.toLocaleDateString('uk-UA', options).replace(',', '');
	return formattedDate;
};
